<template>
  <div v-show="message">
    <template v-if="Array.isArray(message)">
      <p class="text-sm text-red-600">
        {{ message }}
      </p>
    </template>
    <p v-else class="text-sm text-red-600">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: [Array, String],
      default: '',
    },
  },
}
</script>
